export const UTILITIES = {
  WATER: 'Water',
  ELECTRICITY: 'Electricity'
}
